<template>
  <div
    id="surface-header"
    :class="['app-bar', 'surface-header']"
    :data-luminance="realBackgroundLuminance"
    :style="{ 'background-color': realBackgroundColor }"
  >
    <div class="rubber-band-scroll-padder" :style="{ 'background-color': backgroundColor }" />
    <SurfaceNav v-if="xNav" />
    <surface-title @title-changed="updateHeaderHeight" @description-changed="updateHeaderHeight" />
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import SurfaceNav from 'vuecomponents/SurfaceNav'
import SurfaceTitle from 'vuecomponents/surface_title'
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  components: { SurfaceNav, SurfaceTitle },
  computed: {
    ...mapState(['isElectronApp']),
    ...mapGetters([
      'backgroundColor',
      'backgroundLuminance',
      'colorScheme',
      'isMap',
      'amIRegistered',
      'isTitleBarTransparent',
    ]),
    xNav() {
      return !this.$store.isApp
    },
    realBackgroundColor() {
      if (this.isMap) {
        return this.colorScheme === 'light' ? '#FFFFFF' : '#000000'
      }
      if (this.isTitleBarTransparent) {
        return 'transparent'
      }
      return this.backgroundColor
    },
    realBackgroundLuminance() {
      if (this.isMap) {
        return this.colorScheme
      }
      return this.backgroundLuminance
    },
  },
  mounted() {
    // Don't prompt for notifications if the user is not registered and the app is not the electron app
    if (this.amIRegistered && !this.isElectronApp) this.checkAndSubscribeToPushNotifications()
    this.updateHeaderHeight()
  },
  methods: {
    ...mapActions(['resizeHeader', 'checkAndSubscribeToPushNotifications']),
    updateHeaderHeight() {
      this.$nextTick(() => {
        this.resizeHeader({ height: this.$el.offsetHeight })
      })
    },
  },
}
</script>

<style>
.rubber-band-scroll-padder {
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: -100vh;
}
</style>
